import { Box, CircularProgress, Grid, Typography, Zoom } from "@mui/material"
import React, { useCallback, useContext, useMemo, useState } from "react"
import { customPalette } from "../../../../../../../theme"
import { CustomPagination } from "../../../../../../components/buttons/pagination/CustomPagination"
import { RseeDocumentCard } from "../../../../../../components/card/rsee/RseeDocumentCard"
import { SearchAndFilter } from "../../../../../../components/FilterListDrawer/SearchAndFilter"
import { RseeDocumentListContext } from "../../../../../../core/context/beem-pilot/rsee/RseeDocumentListContext"
import { Project } from "../../../../../../core/dto/project/Project"
import { RseeDocument } from "../../../../../../core/dto/rsee/rsee-document"

const ITEMS_PER_PAGE = 6

interface IProps {
  project: Project
}

export function RseeDocumentList({ project }: Readonly<IProps>): React.JSX.Element {
  const { rseeDocumentList, isLoading } = useContext(RseeDocumentListContext)

  const [page, setPage] = useState(1)

  const handleChangePage: (event: any, value: number) => void = useCallback(
    (event, value) => {
      setPage(value)
    },
    [setPage]
  )

  const [searchValue, setSearchValue] = useState<string>("")

  const rseeDocumentToShow = useMemo(() => {
    const list = rseeDocumentList
    if (searchValue !== "") {
      return list.filter((rseeDocument) => rseeDocument.filename.toLowerCase().includes(searchValue.toLowerCase()))
    }
    return list
  }, [rseeDocumentList, searchValue])

  function handleSearch(newSearchState: string): void {
    setSearchValue(newSearchState)
  }

  return (
    <>
      <Grid item xs={5}>
        <SearchAndFilter
          searchStateLabel="Rechercher par nom"
          searchState={searchValue}
          handleSearch={handleSearch}
          isFilterDrawer={false}
        />
      </Grid>

      <Box>
        {isLoading ? (
          <CircularProgress />
        ) : (
          <Grid container columnSpacing={4} alignItems="flex-start" height="100%" rowGap={3}>
            {rseeDocumentToShow.length > 0 ? (
              rseeDocumentToShow.map((rseeDocument: RseeDocument, index) => (
                <Zoom in style={{ transitionDelay: `${index * 150}ms` }} key={rseeDocument.id}>
                  <Grid item xs={12} md={4} lg={4}>
                    <RseeDocumentCard key={rseeDocument.id} rseeDocument={rseeDocument} project={project} />
                  </Grid>
                </Zoom>
              ))
            ) : (
              <Box
                display="flex"
                flexDirection="column"
                justifyContent="center"
                alignItems="center"
                height="100%"
                width="100%">
                <Typography
                  fontSize="24px"
                  fontWeight={600}
                  lineHeight="36px"
                  textAlign="center"
                  color={customPalette.darkBlue3}>
                  Aucun résultat
                </Typography>
                <Typography variant="body1">Modifier les options de recherche.</Typography>
              </Box>
            )}
          </Grid>
        )}
        {project && !isLoading && (
          <CustomPagination
            count={Math.ceil(rseeDocumentList.length / ITEMS_PER_PAGE)}
            page={page}
            handlePagination={handleChangePage}
          />
        )}
      </Box>
    </>
  )
}
